// Sprint T-22 · NotificationSearch · input con debounce
import React, { useEffect, useState } from "react";
import { MagnifyingGlass, X } from "@phosphor-icons/react";

const DEBOUNCE_MS = 300;

/**
 * Input de búsqueda con debounce · llama a `onDebouncedChange(term)` 300ms
 * después del último keystroke. Rango máximo 200 chars (validado en backend).
 */
export const NotificationSearch = ({
  value = "",
  onDebouncedChange,
  placeholder = "Buscar en notificaciones…",
}) => {
  const [local, setLocal] = useState(value);

  // Sync external value → local (por ejemplo, al abrir el modal)
  useEffect(() => {
    setLocal(value);
  }, [value]);

  // Debounce local → onDebouncedChange
  useEffect(() => {
    const t = setTimeout(() => {
      if (local !== value) onDebouncedChange?.(local);
    }, DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [local, value, onDebouncedChange]);

  const clear = () => {
    setLocal("");
    onDebouncedChange?.("");
  };

  return (
    <div className="relative" data-testid="notif-search">
      <MagnifyingGlass
        size={14}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ag-text-dim)]"
      />
      <input
        type="search"
        role="searchbox"
        value={local}
        onChange={(e) => setLocal(e.target.value.slice(0, 200))}
        placeholder={placeholder}
        className="w-full pl-8 pr-8 py-2 text-sm bg-[var(--ag-midnight)]/60 border border-[var(--ag-border)] rounded-md text-white placeholder:text-[var(--ag-text-dim)] focus:outline-none focus:ring-2 focus:ring-[var(--ag-amber,#f59e0b)]/40 focus:border-[var(--ag-amber,#f59e0b)]/40"
        aria-label="Buscar en notificaciones"
        data-testid="notif-search-input"
      />
      {local && (
        <button
          type="button"
          onClick={clear}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-[var(--ag-text-dim)] hover:text-white p-1 rounded"
          aria-label="Limpiar búsqueda"
          data-testid="notif-search-clear"
        >
          <X size={12} />
        </button>
      )}
    </div>
  );
};

export default NotificationSearch;
